import { i18n } from "services/i18nService";

import { initialErrorState } from "views/common";

export function isValid(record) {
  const errors = initialErrorState();
  errors.entity = [];

  if (!record.firstName) {
    errors.messages.push(i18n("isValid.FirstName"));
    errors.entity.push("firstName");
  }

  return errors;
}
